"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const title_1 = __importDefault(require("./title"));
const file_1 = __importDefault(require("./file"));
const fields = {
    FileUploadField: file_1.default,
    TitleField: title_1.default
};
exports.default = fields;
//# sourceMappingURL=index.js.map